import './staffMembers.scss';
import * as React from 'react';
import useAllStaffMembersBusiness from '../../hooks/staticQueries/staff/useStaffMembersBusiness';
import useStaffMembersDesign from '../../hooks/staticQueries/staff/useStaffMembersDesign';
import useAllStaffMembersDevelopment from '../../hooks/staticQueries/staff/useStaffMembersDevelopment';
import useStaffMembersNonManagement from '../../hooks/staticQueries/staff/useStaffMembersNonManagement';
import { StaffMember } from './staffMember';
export const StaffMembers = ({ staffMembers }) => (<div className="staff-members">
    {staffMembers.map((staffMemeber) => (<StaffMember key={staffMemeber.name} staffMember={staffMemeber}/>))}
  </div>);
export const AllStaffMembers = () => {
    const { people } = useStaffMembersNonManagement();
    return <StaffMembers staffMembers={people}/>;
};
export const StaffMembersDevelopment = () => {
    const { people } = useAllStaffMembersDevelopment();
    return <StaffMembers staffMembers={people}/>;
};
export const StaffMembersBusiness = () => {
    const { people } = useAllStaffMembersBusiness();
    return <StaffMembers staffMembers={people}/>;
};
export const StaffMembersDesign = () => {
    const { people } = useStaffMembersDesign();
    return <StaffMembers staffMembers={people}/>;
};
